import React from 'react';

const FeatureContext = React.createContext({
  feature: () => {},
});

export default FeatureContext;
